import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Toggle from './../Toggle';
import RadioGroup from '../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { saloon_view01ImageOptions } from './views/Saloon_view01'

class X56Saloon extends Component {
    constructor(props) {
        super(props);
        this.handleTableBoxChange = this.handleTableBoxChange.bind(this);
        this.handlePouffesChange = this.handlePouffesChange.bind(this);
        this.handleBackrestChange = this.handleBackrestChange.bind(this);
        this.handleLayoutChange = this.handleLayoutChange.bind(this);
    }

    handleTableBoxChange(event) {
        let configuration = this.props.configuration;
        configuration.TableBox = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handlePouffesChange(event) {
        let configuration = this.props.configuration;
        configuration.SaloonPouffe = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleBackrestChange(event) {
        let configuration = this.props.configuration;
        configuration.SaloonBackRest = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }


    handleLayoutChange(newValue) {
        let configuration = this.props.configuration;
        configuration.SaloonTableBox = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = saloon_view01ImageOptions;

        let image = <ConfiguratorImage boat="X5_6" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

                    <h1><Trans defaults='Saloon' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='Upper cupboards in the saloon, dining table without table/drinks box below, coffee table & back rest cushions on mail bulkhead are all standard.' /></p>
                    <p><Trans defaults='Optional is luxury main cabin dining table.' /></p>


                    <RadioGroup label={this.props.configuration.SaloonTableBox.label} options={this.props.tableOptions} value={this.props.configuration.SaloonTableBox} onChange={this.handleLayoutChange} />

                    <Toggle checked={this.props.configuration.SaloonPouffe.value === 2} onChange={this.handlePouffesChange}>
                        <Trans defaults='Coffee table (an be converted into a pouffe at the saloon table)' />
                    </Toggle>

                    <Toggle checked={this.props.configuration.SaloonBackRest.value === 2} onChange={this.handleBackrestChange}>
                        <Trans defaults='Back rest cushions on main bulkhead' />
                    </Toggle>


                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X56Saloon);


// WEBPACK FOOTER //
// ./src/X56/X56Saloon.js